import { ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavContent } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-scroll-to-top',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './scroll-to-top.component.html',
  styleUrl: './scroll-to-top.component.scss',
})
export class ScrollToTopComponent implements OnInit, OnDestroy {
  @Input() scrollContainer!: MatSidenavContent;
  private cdr = inject(ChangeDetectorRef);
  visible = false;
  private sub = Subscription.EMPTY;

  ngOnInit() {
    this.sub = this.scrollContainer.elementScrolled().subscribe(() => {
      this.visible = this.scrollContainer.measureScrollOffset('top') > 300;
      this.cdr.detectChanges();
    });
  }

  scrollToTop() {
    this.scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
